module.exports = __webpack_public_path__ + "static/Process_2-98c477eb18181a53847850859877a162.jpg";